import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { map, Observable } from 'rxjs';
import { ODataRequest } from '../utilities/sdk-base/o-data-request';
import { PagingResponse } from '@models/paging-response.model';
import { LoginAttemptCollection } from '../models/ui/login-attempt-collection.model';
import { LoginTrackerResource } from '../models/resource/login-tracker.resource';
import { LoginTrackerResourceToLoginAttemptMapper } from '../models/mappers/login-tracker-resource-to-login-attempt.mapper';

const mapper = new LoginTrackerResourceToLoginAttemptMapper();

@Injectable({ providedIn: 'root' })
export class LoginTrackerSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public get(params?: LoginAttemptGetParams): Observable<LoginAttemptCollection> {
		const request = new ODataRequest('get', 'LoginTrackers')
			.$orderBy('utcDateTime', 'desc')
			.$count();

		if (params?.top) {
			request.$top(params?.top);
		}

		if (params?.skip) {
			request.$skip(params?.skip);
		}

		return this.makeODataRequest$<PagingResponse<LoginTrackerResource>>(request, 'api2').pipe(
			map((response) => {
				const result = new LoginAttemptCollection();
				result.items = mapper.mapCollection(response.value);
				result.totalItems = response.count;
				return result;
			})
		);
	}
}

interface LoginAttemptGetParams {
	top: number;
	skip: number;
}
